<template>
  <div class="customPage">
    <h2 class="customPageTitle">ERROR</h2>
    <v-container class="customPageContent text-center">
      <div class="customPageTitle pink mb-2">이런! 잘못된 페이지에요.</div>
      <p class="customPageSubtitle">
        접근하시려는 페이지 주소가 잘못 되었어요!
        <br>
        페이지가 없거나, 변경 되어 찾을 수가 없어요 :(
      </p>
      <v-btn class="customButton" @click="$router.push('/')">메인으로</v-btn>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "Error"
};
</script>
